(function() {
  var REGION_CENTERS = {
    '1': [52.37, 4.90], '2': [52.10, 4.30], '3': [52.09, 5.12],
    '4': [51.59, 4.78], '5': [51.44, 5.48], '6': [50.85, 5.69],
    '7': [52.22, 6.89], '8': [52.78, 6.10], '9': [53.22, 6.57]
  };

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function(c) {
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }

  function normalizePostcode(input) {
    if (!input) return null;
    var cleaned = input.replace(/\s/g, '').toUpperCase();
    var match = cleaned.match(/^(\d{4})([A-Z]{2})?$/);
    if (!match) return null;
    return {
      digits: match[1],
      letters: match[2] || '',
      formatted: match[1] + (match[2] ? ' ' + match[2] : ''),
      bare: match[1] + (match[2] || '')
    };
  }

  function initSection(section) {
    if (section.dataset.grInitialized) return;
    section.dataset.grInitialized = 'true';

    var sectionId = section.dataset.sectionId;
    var productHandle = section.dataset.productHandle || 'travel-probiotics';
    var copy = {
      newsletterTitle: section.dataset.newsletterTitle || '',
      newsletterSubtitle: section.dataset.newsletterSubtitle || '',
      newsletterBtnLabel: section.dataset.newsletterBtnLabel || 'Aanmelden',
      onlinePromptText: section.dataset.onlinePromptText || '',
      onlinePromptLink: section.dataset.onlinePromptLink || '',
      successText: section.dataset.successText || ''
    };

    var postcodeInput = section.querySelector('[data-gr-postcode]');
    var searchBtn = section.querySelector('[data-gr-search-btn]');
    var resultsEl = section.querySelector('[data-gr-results]');
    if (!postcodeInput || !searchBtn || !resultsEl) return;

    initMap(section, sectionId, 0);

    postcodeInput.addEventListener('input', function(e) {
      var val = e.target.value.toUpperCase().replace(/\s/g, '');
      if (val.length > 4) val = val.slice(0, 4) + ' ' + val.slice(4, 6);
      e.target.value = val;
    });

    postcodeInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); searchBtn.click(); }
    });

    searchBtn.addEventListener('click', function() {
      var pc = normalizePostcode(postcodeInput.value);
      if (!pc) {
        showInvalidState(resultsEl);
        postcodeInput.focus();
        return;
      }
      showEmptyState(section, resultsEl, pc, copy, productHandle);
    });
  }

  function initMap(section, sectionId, retries) {
    if (typeof L === 'undefined') {
      if (retries > 30) return;
      setTimeout(function() { initMap(section, sectionId, (retries || 0) + 1); }, 100);
      return;
    }
    var mapEl = document.getElementById('gr-map-' + sectionId);
    if (!mapEl || mapEl.dataset.initialized) return;
    mapEl.dataset.initialized = 'true';

    var isDark = document.documentElement.classList.contains('dark');
    var tileUrl = isDark
      ? 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png'
      : 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png';

    var map = L.map(mapEl, {
      center: [52.2, 5.4],
      zoom: 7,
      minZoom: 6,
      maxZoom: 12,
      scrollWheelZoom: false,
      zoomControl: true,
      attributionControl: true
    });

    L.tileLayer(tileUrl, {
      attribution: '\u00a9 OpenStreetMap, \u00a9 CARTO',
      subdomains: 'abcd',
      maxZoom: 19
    }).addTo(map);

    section._grMap = map;
  }

  function showInvalidState(resultsEl) {
    resultsEl.innerHTML = '<div class="gr-sf-empty"><div class="gr-sf-empty__head"><div class="gr-sf-empty__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="13"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg></div><div><h3 class="gr-sf-empty__title">Vul een Nederlandse postcode in</h3><p class="gr-sf-empty__text">Bijvoorbeeld 1234 AB of 1234.</p></div></div></div>';
  }

  function showEmptyState(section, resultsEl, pc, copy, productHandle) {
    var pcDisplay = escapeHtml(pc.formatted);
    var html = '<div class="gr-sf-empty">'
      + '<div class="gr-sf-empty__head">'
      + '<div class="gr-sf-empty__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="10" r="3"/><path d="M12 2 C7.5 2 4 5.5 4 10 c0 6 8 12 8 12 s8-6 8-12 c0-4.5-3.5-8-8-8z"/></svg></div>'
      + '<div>'
      + '<h3 class="gr-sf-empty__title">Nog geen winkel in de buurt van ' + pcDisplay + '</h3>'
      + '<p class="gr-sf-empty__text">Gut Ready breidt nog uit. We laten het je graag weten zodra we bij jou in de buurt te koop zijn.</p>'
      + '</div>'
      + '</div>'
      + '<div class="gr-sf-newsletter">'
      + '<p class="gr-sf-newsletter__title">' + escapeHtml(copy.newsletterTitle) + '</p>'
      + '<p class="gr-sf-newsletter__subtitle">' + escapeHtml(copy.newsletterSubtitle) + '</p>'
      + '<form data-gr-newsletter-form novalidate>'
      + '<input type="hidden" name="postcode" value="' + pcDisplay + '">'
      + '<div class="gr-sf-newsletter__row">'
      + '<input type="email" name="email" class="gr-sf-input" placeholder="je@email.com" required style="text-transform:none;letter-spacing:normal">'
      + '<button type="submit" class="gr-sf-btn gr-sf-btn--primary">' + escapeHtml(copy.newsletterBtnLabel) + '</button>'
      + '</div>'
      + '<p class="gr-sf-newsletter__error" data-gr-error style="display:none"></p>'
      + '</form>'
      + '</div>'
      + '<p class="gr-sf-online-prompt">' + escapeHtml(copy.onlinePromptText) + ' <a href="/products/' + escapeHtml(productHandle) + '" class="gr-sf-online-link">' + escapeHtml(copy.onlinePromptLink) + '</a></p>'
      + '</div>';

    resultsEl.innerHTML = html;

    var form = resultsEl.querySelector('[data-gr-newsletter-form]');
    if (form) {
      form.addEventListener('submit', function(e) { handleNewsletterSubmit(e, copy); });
    }

    if (window.innerWidth < 750) {
      resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    if (section._grMap && pc.digits) {
      var center = REGION_CENTERS[pc.digits.charAt(0)] || [52.2, 5.4];
      try { section._grMap.flyTo(center, 9, { duration: 1.2 }); } catch (err) {}
    }
  }

  function handleNewsletterSubmit(e, copy) {
    e.preventDefault();
    var form = e.currentTarget;
    var emailInput = form.querySelector('input[name="email"]');
    var postcodeInput = form.querySelector('input[name="postcode"]');
    var errorEl = form.querySelector('[data-gr-error]');
    var btn = form.querySelector('button[type="submit"]');
    var email = emailInput.value.trim();
    var postcode = postcodeInput.value;

    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      errorEl.textContent = 'Vul een geldig e-mailadres in.';
      errorEl.style.display = 'block';
      emailInput.focus();
      return;
    }

    errorEl.style.display = 'none';
    btn.disabled = true;
    btn.textContent = 'Bezig...';

    var formData = new FormData();
    formData.append('form_type', 'customer');
    formData.append('utf8', '\u2713');
    formData.append('contact[email]', email);
    formData.append('contact[tags]', 'newsletter,store-finder,postcode-' + postcode.replace(/\s/g, ''));
    formData.append('contact[note]', 'Postcode: ' + postcode + ' (via waar-te-koop)');
    formData.append('contact[accepts_marketing]', 'true');

    fetch('/contact#contact_form', {
      method: 'POST',
      body: formData,
      mode: 'no-cors'
    }).then(function() { showSuccessState(form, copy); })
      .catch(function() { showSuccessState(form, copy); });
  }

  function showSuccessState(form, copy) {
    var card = form.closest('.gr-sf-newsletter');
    if (!card) return;
    card.innerHTML = '<div class="gr-sf-newsletter__success">'
      + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>'
      + '<span>' + escapeHtml(copy.successText) + '</span>'
      + '</div>';
  }

  function init() {
    document.querySelectorAll('.gr-store-finder').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
